import React from 'react';
import '../css/Organizadores.css';

function Organizadores() {
  return (
    <div className="organizadores">
      <h1>Organizadores</h1>
      <p>El Congreso Patagónico de Alimentos es organizado por diversas instituciones comprometidas con la ciencia y tecnología de los alimentos.</p>

      <h2>Instituciones Organizadoras</h2>
      <ul>
        <li>Facultad de Ciencias Veterinarias. Universidad Nacional de La Pampa</li>
        <li>Facultad de Agronomía. Universidad Nacional de La Pampa</li>
        <li>Escuela de Veterinaria y Producción Agroindustrial, Sede Alto Valle - Valle Medio. Universidad Nacional de Río Negro</li>
        <li>Escuela de Producción, Tecnología y Medio Ambiente, Sede Alto Valle - Valle Medio. Universidad Nacional de Río Negro</li>
        <li>Facultad Regional de Tierra del Fuego. Universidad Tecnológica Nacional</li>
        <li>Facultad Regional de Chubut. Universidad Tecnológica Nacional</li>
        <li>Escuela de Producción, Ambiente y Desarrollo Sostenible. Universidad Chubut</li>
        <li>Facultad de Ciencia y Tecnología de los Alimentos. Universidad Nacional del Comahue</li>
      </ul>

      <h2>Autoridades del Congreso</h2>
      <ul>
        <li>Presidenta: Esp. Mariana Forte. Facultad de Ciencias Veterinaria, Universidad Nacional de La Pampa</li>
        <li>Vicepresidenta: Lic. Mariana Serra. Facultad Regional Chubut. Universidad Tecnológica Nacional.</li>
      </ul>

      <h2>Comité Organizador</h2>
      <ul>
        <li>Dra. Natalia Bongiovani. Escuela de Producción, Tecnología y Medio Ambiente, Sede Alto Valle- Valle Medio. Universidad Nacional de Río Negro</li>
        <li>Dra. Lucía da Cruz Cabral. Facultad Regional Chubut. Universidad Tecnológica Nacional.</li>
        <li>Dr. Mario José Calafat. Facultad de Agronomía. Universidad Nacional de La Pampa.</li>
        <li>Dra. Silvia Marina Ardoino. Facultad de Ciencias Veterinaria. Universidad Nacional de La Pampa.</li>
        <li>Lic. Rocio Ramirez Ilariuzzi. Facultad de Ciencias Veterinaria. Universidad Nacional de La Pampa.</li>
        <li>Dr. Mauricio Miguel Coletto. Escuela de Producción, Tecnología y Medio Ambiente, Sede Alto Valle- Valle Medio. Universidad Nacional de Río Negro</li>
        <li>Dr. María Belen Buglione. Escuela de Veterinaria y Producción Agroindustrial, Sede Alto Valle- Valle Medio. Universidad Nacional Río Negro</li>
        <li>Mg. Emilce Rojo. Facultad de Ciencias Veterinaria. Universidad Nacional de La Pampa.</li>
        <li>Dra. Mónica Kozykariski. Escuela de Producción, Ambiente y Desarrollo Sostenible. Universidad del Chubut.</li>
        <li>Mg. Valentín Tassile. Facultad de Ciencias y Tecnología de los Alimentos. Universidad Nacional del Comahue.</li>
        <li>Dr. Maria Belén Mazzucco. Facultad de Ciencias y Tecnología de los Alimentos. Universidad Nacional del Comahue.</li>
        <li>Ing. Francisco Nuñez. Facultad Regional de Tierra del Fuego. Universidad Tecnológica Nacional.</li>
        <li>M.V. Soledad Gurisich. Facultad Regional Chubut. Universidad Tecnológica Nacional.</li>
      </ul>

      <h2>Comité Académico Científico</h2>
      <ul>
        <li>Maria bettibna Gomez — Facultad de Ciencias Veterinarias y Facultad de Ciencias de la Salud UNLPam</li>
        <li>María Juliana Dielschneider — Fac. de Cs. Veterinarias / Ingeniería, UNLPam</li>
        <li>Lucía da Cruz Cabral — Facultad Regional Chubut, UTN</li>
        <li>Claudia Andrea Tortone — Facultad de Ciencias Veterinarias, UNLPam</li>
        <li>Adriana Beatriz Simes — Facultad de Ciencias y Tecnología de los Alimentos, UNCo</li>
        <li>María Soledad Gurisich — UTN FRCH</li>
        <li>Lorena Franceschinis — Facultad de Ciencias y Tecnología de los Alimentos, UNCo</li>
        <li>Elizabeth Haydee Ohaco Dominguez — FACTA, Universidad Nacional del Comahue</li>
        <li>Indira Marián Gatti — Universidad del Chubut</li>
        <li>María Clara Tarifa — Universidad Nacional de Río Negro (Escuela de Producción, Tecnología y Medio Ambiente)</li>
        <li>María Belén Paesani — FCV, INTI</li>
        <li>Susana Diez — PROBIEN</li>
        <li>Ana Laura Ardiles — Universidad del Chubut</li>
        <li>Andres Felipe Rocha Parra — UNRN</li>
        <li>Mariana Forte — Facultad de Ciencias Veterinarias, UNLPam</li>
        <li>María Belén Buglione — Universidad Nacional de Río Negro</li>
        <li>Javier Cerliani — Facultad de Cs. veterinarias-UNLPam</li>
        <li>Maria Isabel Lujan — Facultad Ciencia Tecnologia de los Alimentos- UNCo</li>
        <li>Diego Fernando Rocha Parra — CONICET/Universidad Nacional de Rio Negro</li>
        <li>Cecilia Belen Schiaffino — UNLPAM</li>
        <li>Maria Belen Mazzucco — UNIVERSIDAD NACIONAL DEL COMAHUE, FACTA</li>
        <li>Soraya Ivonne Corvalan — UTN FRCH</li>
        <li>Mónica Primost — UTN-FRCH</li>
        <li>Delia Williamson — Fcv UNLPAM</li>
        <li>María Belén Paesani — Fac . De cs.veterinarias / INTI</li>
        <li>Mariela Alejandra García Cachau — Facultad de Cs Veterinarias UNLPam</li>
        <li>Facundo Carlos Namor — Facultad de Ciencias y Tecnología de los Alimentos, Universidad Nacional del Comahue</li>
        <li>Pedro Vicente Palermo — Fac. Cs. Veterinarias</li>
        <li>Rocio Liz Ramirez Ilariuzzi — Facultad de Ciencias Veterinarias- UNLPAM</li>
        <li>María Ana Loubes — Instituto de Tecnología de Alimentos y Procesos Químicos (ITAPROQ) - CONICET - UBA; Departamento de Industrias - FCEyN - UBA</li>
        <li>Carolina Antonella Paulino — Facultad de Ciencias y Tecnologia de los Alimentos - Universidad Nacional del Comahue</li>
        <li>Yolanda Leticia Curilén — Facultad de Ciencias y Tecnología de los Alimentos - Uncomahue</li>
        <li>Otrosky Roberto — FCV-UNLPam</li>
        <li>Mauricio Miguel Coletto — Escuela de Producción, Tecnología, y Medio Ambiente, Sede AV-VM, UNRN</li>
        <li>Natalia Bongiovani — Universidad Nacional de Río Negro</li>
        <li>Fernando Gaspar Dellatorre — UTN FRCH</li>
        <li>Daniela Marisol Salvatori — Universidad Nacional del Comahue- Facultad de Ciencias y Tecnología de los Alimentos</li>
        <li>Patricia Angelica Barril — CIATI</li>
        <li>Silvana Mariela Azcarate — INCITAP-CONICET-UNLPam</li>
        <li>Rosa Karina Nesprias — UNIVERSIDAD NCIONAL DEL CENTRO DE LA PROVINCIA DE BUENOS AIRES</li>
        <li>Emilse Rojo — Universidad Nacional de la Pampa, Facultad de Ciencias Veterinarias</li>

      </ul>
    </div>
  );
}

export default Organizadores;
